import fetchClient from '@/api/api-client'

export async function listUsers(params, limit, next) {
  try {
    const payload = {
      params,
      limit,
      pageToken: next,
    }
    const res = await fetchClient.post(`/users`, payload)

    return res.data.data
  } catch (err) {
    throw err
  }
}
// export async function listUsersPaginate(params, limit, next) {
//   try {
//     const payload = {
//       params,
//       limit,
//       pageToken: next,
//     }
//     // console.log(payload);
//     const res = await fetchClient.post(`/users/withpaginate`, payload)
//     //const res = await axios.post(`${BASEURL}/users/withpaginate`, payload);
//     return res.data
//   } catch (err) {
//     throw err
//   }
// }

export async function getUser(params) {
  try {
    const res = await fetchClient.get(`/users/${params}`)
    //const res = await axios.get(`${BASEURL}/users/${params}`)
    return res.data.data
  } catch (err) {
    throw err
  }
}

// export async function getAllUsers(params) {
//   try {
//     const res = await fetchClient.get(`/users/`)
//     //const res = await axios.get(`${BASEURL}/users/`)
//     return res.data.data
//   } catch (err) {
//     throw err
//   }
// }

export async function getCurrentUser() {
  try {
    const res = await fetchClient.get(`/users/currentUser`)
    //const res = await axios.get(`${BASEURL}/users/currentUser`, config)
    return res.data.data
  } catch (_err) {
    // console.log("getCurrentUser - err", err)
  }
}

export async function updateUser(params) {
  try {
    const res = await fetchClient.post(`/users/update`, params)
    //const res = await axios.post(`${BASEURL}/users/update`, payload)
    return res.data.data
  } catch (err) {
    throw err
  }
}

export async function deleteUser(username) {
  try {
    const res = await fetchClient.delete(`/users/${username}`)
    return res.data.data
  } catch (err) {
    throw err
  }
}

export async function confirmUser(username) {
  try {
    const res = await fetchClient.post(`/auth/admin-confirm-user`, { username })
    return res.data.data
  } catch (err) {
    throw err
  }
}

// workers

export async function getAllWorkers() {
  try {
    const res = await fetchClient.get(`/users/workers/all`)
    //const res = await axios.get(`${BASEURL}/users/workers/all`)
    return res.data.data
  } catch (err) {
    throw err
  }
}

export async function addRoleWorkerToUser(params) {
  try {
    const payload = {
      params,
    }

    const res = await fetchClient.post(`/users/workers/add_role`, payload)
    //const res = await axios.post(`${BASEURL}/users/workers/add_role`, payload)
    return res.data.data
  } catch (err) {
    throw err
  }
}

export async function removeRoleWorkerToUser(params) {
  try {
    const payload = {
      params,
    }

    const res = await fetchClient.post(`/users/workers/remove_role`, payload)
    //const res = await axios.post(`${BASEURL}/users/workers/remove_role`, payload)
    return res.data.data
  } catch (err) {
    throw err
  }
}

export async function currentAuthenticatedUser() {
  try {
    const token = JSON.parse(localStorage.getItem('cognito-tokens'))
    return token && (await getCurrentUser(token.accessToken))
  } catch (_err) {
    // console.log("currentAuthenticatedUser - err", err)
  }
}
